import { isVariationArchived, type Variation } from 'src/data/variation';

export const hasNonArchivedVariations = (variations: Variation[]): boolean => {
  if (!Array.isArray(variations) || variations.length === 0) {
    return false;
  }

  return variations.some((variation: Variation) => {
    if (!isVariationArchived(variation)) {
      return true;
    }

    if (variation?.variations?.length) {
      return hasNonArchivedVariations(variation?.variations);
    }

    return false;
  });
};
